import http from './http';

export function getLoginUserBaseInfo() {
  return http.get('/Account/GetLoginUserBaseInfo');
}

export function getMLoginUserBaseInfo() {
  return http.get('/Account/GetMLoginUserBaseInfo');
}

export function getLoginInfo() {
  return http.get('/Account/GetLoginUserInfo');
}
